var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"containers"},[_c('img',{attrs:{"src":require("../assets/developing.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.title))])]),_c('Foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }